import { css } from '@emotion/css'
import { hexToRgba } from '../../../themes/helpers'
import { colors } from '../../../themes'
import { shorthandHelper } from '../../../styles/helpers'
import { borderRadius, fontSize, fontWeight, fontFamily, spacing } from '../../../styles'

const styles = {
  heading: css({
    borderRadius: borderRadius.default,
    backgroundColor: colors.athensGray,
    boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    fontFamily: fontFamily.body,
    color: colors.jumbo,
    padding: shorthandHelper([spacing.small, spacing.default]),
  }),
}

export default styles
